import React from 'react';
import ErrorIcon from '../Base';
import ErrorIconComponent from './style';

const Index = (props) => {
  return <ErrorIcon {...props} ErrorIconComponent={ErrorIconComponent} />;
};

export default Index;
